import { PLANOGRAM_VERSION_STATUS } from '../../constants';

/* eslint-disable */
export const IN_PROGRESS_VERSION_TEXT = {
  [PLANOGRAM_VERSION_STATUS.generating]: `The Sphere is being ${PLANOGRAM_VERSION_STATUS.generating}. The access will be provided after process completion.`,
  [PLANOGRAM_VERSION_STATUS.publishing]: `The Sphere is being ${PLANOGRAM_VERSION_STATUS.publishing}. The access will be provided after process completion.`,
  [PLANOGRAM_VERSION_STATUS.drafting]: `The draft Sphere is being created. Access will be provided after the process is complete.`,
};
